import * as signalR from '@microsoft/signalr';
import { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack';

import config from '../../config.json';
import logService from './logService3';

import { publish } from '../utils/pubsub';

// portal streamer
// const websocketEndpoint = config.streamUrl;

// gateway streamer
const websocketEndpoint = config.gatewayStreamEndpoint;

let _endpoint = '';
let _logCtx = null;

// https://learn.microsoft.com/en-us/aspnet/core/signalr/scale?view=aspnetcore-8.0
// example with REDIS backplane and nginx configs
export default class SystemSocket {
    options = {
        transport: signalR.HttpTransportType.WebSockets,
        skipNegotiation: true,
        logMessageContent: false,
        logger: signalR.LogLevel.None,
    };

    constructor(props) {
        this._name = 'SystemSocket';
    }

    init = async (endpoint, onSocketError, onSocketStateChanged, logCtx) => {
        _endpoint = endpoint;

        _logCtx = logCtx;

        this.onSocketError = onSocketError;
        this.onStateChanged = onSocketStateChanged;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(websocketEndpoint + '/' + endpoint, this.options)
            .configureLogging(signalR.LogLevel.Information)
            .withHubProtocol(new MessagePackHubProtocol())
            .withServerTimeout(60 * 60 * 1000)
            .withKeepAliveInterval(1000)
            .build();

        try {
            connection.onclose(() => this.onStateChanged(connection._connectionState));
            // this.onStateChanged(connection.connectionState);

            // this is already an socket connection for "normal commands"
            await connection.start();
            publish('SystemSocketConnected');

            // console.log('connected socketClient.init: ');

            logService.log('connected socketClient.init: ', _logCtx);
        } catch (ex) {
            publish('SystemSocketError', { error: ex }); // ADDED
            console.log('FATAL socketClient.init: ', ex);
            return null;
        }

        return connection;
    };

    subscribeTo = (streamName, connection, onMessage) => {
        try {
            console.log(`socketClient: subscribing ${streamName}`);

            // this is a stream connection
            const subscription = connection.stream(streamName).subscribe({
                next: onMessage,
                error: (err) => {
                    // console.log(`${this._name} subscription error: ${err}`, err);
                    // onStateChanged(connection.state);

                    this.onSocketError(err);
                },
                complete: () => {
                    // onSocketError(connection.state);
                    console.log(`${this._name} complete`);
                },
            });

            return subscription;
        } catch (ex) {
            console.log('socketClient.subscribeTo fatal: ', ex);
            return null;
        }
    };
}

// const systemSocket = new SystemSocket();
// export default systemSocket;
